<template>
  <div :class="(total_coupons==0||total_group==0)?'wrapper noTabs':'wrapper'">
    <van-popup v-model="areaShow" :lock-scroll="true">
      <div class="areaPopup">
        <div class="areaTitle">可用{{areaTitle}}</div>
        <span class="areaText">{{areaText}}</span>
      </div>
    </van-popup>
    <div class="bottom">
      <van-tabs
        sticky
        animated
        color="#E52B25"
        :line-width="20"
        :swipeable="(total_coupons==0||total_group==0)?false:true"
        v-model="active"
      >
        <van-tab title="精选好券">
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <van-list
              class="listItem"
              :immediate-check="false"
              v-model="menu[0].loading"
              :finished="menu[0].finished"
              :offset="20"
              @load="getData"
            >
              <div
                :class="Number(item.user_get_num)>=Number(item.get_limit_num)?'volume active':'volume'"
                v-for="(item,index) in menu[0].list"
                :key="index"
              >
                <div class="left">
                  <span class="one">
                    <span>￥</span>
                    <div class="amount">{{parseFloat(parseFloat(item.total_amount).toFixed(2))}}</div>
                  </span>
                  <span
                    class="two"
                    v-if="item.is_coupon_group=='0'&&item.limit_condition>0"
                  >满{{parseFloat(parseFloat(item.limit_condition).toFixed(2))}}元可使用</span>
                  <span class="two" v-if="item.is_coupon_group=='0'&&item.limit_condition==0">无门槛券</span>
                  <span class="two" v-if="item.is_coupon_group=='1'">券组合最高面值</span>
                </div>
                <div class="right">
                  <div class="lefttext">
                    <span class="name">{{item.name}}</span>
                    <span
                      class="couponGroup"
                      v-if="item.is_coupon_group=='1'"
                    >使用规则：单张券限领次数与普通优惠券共用，优惠券的使用时间及适用条件以每张券具体规则为准</span>
                    <span
                      class="time"
                      v-if="item.is_coupon_group=='0'"
                    >{{item.end_time?item.end_time:item.duration + '天'}}到期</span>
                    <span
                      class="time"
                      v-if="item.is_coupon_group=='0'"
                    >每个用户限领{{item.get_limit_num}}次</span>
                    <!-- <span class="area" v-if="item.area_name">
                      限定专场可用
                      <img
                        v-if="Number(item.user_get_num)>=Number(item.get_limit_num)"
                        src="./../../assets/images/myCoupon/fill1.png"
                        alt
                      />
                      <img v-else src="./../../assets/images/myCoupon/fill2.png" alt />
                    </span>
                    <span class="area" v-if="item.commodity_name">
                      限定商品可用
                      <img
                        v-if="Number(item.user_get_num)>=Number(item.get_limit_num)"
                        src="./../../assets/images/myCoupon/fill1.png"
                        alt
                      />
                      <img v-else src="./../../assets/images/myCoupon/fill2.png" alt />
                    </span> -->
                  </div>
                  <div class="rightimg">
                    <img
                      v-if="Number(item.user_get_num)<Number(item.get_limit_num)"
                      src="../../assets/images/securities/one.png"
                      alt
                    />
                    <span
                      v-if="Number(item.user_get_num)<Number(item.get_limit_num)"
                      class="receive"
                      @click.stop="collar(item.nbr,index)"
                    >立即领取</span>
                    <img
                      v-if="Number(item.user_get_num)>=Number(item.get_limit_num)"
                      src="../../assets/images/securities/two.png"
                      alt
                    />
                    <span
                      v-if="Number(item.user_get_num)>=Number(item.get_limit_num)"
                      class="receives"
                    >已领取</span>
                  </div>
                </div>
              </div>
              <div class="no" v-if="total_coupons == 0&&total_group == 0&&!menu[0].loading">
                <img src="./../../assets/images/myCoupon/Bitmap.png" alt />
                <div>当前还没有可领取的优惠券哦~</div>
              </div>
            </van-list>
          </van-pull-refresh>
        </van-tab>
        <van-tab title="优惠券组合">
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <van-list
              class="listItem"
              :immediate-check="false"
              v-model="menu[1].loading"
              :finished="menu[1].finished"
              :offset="20"
              @load="getData"
            >
              <div
                :class="Number(item.user_get_num)>=Number(item.get_limit_num)?'volume active':'volume'"
                v-for="(item,index) in menu[1].list"
                :key="index"
              >
                <div class="left">
                  <span class="one">
                    <span>￥</span>
                    <div class="amount">{{parseFloat(parseFloat(item.total_amount).toFixed(2))}}</div>
                  </span>
                  <span
                    class="two"
                    v-if="item.is_coupon_group=='0'"
                  >满{{parseFloat(parseFloat(item.limit_condition).toFixed(2))}}元可使用</span>
                  <span class="two" v-else>每个用户限领{{item.get_limit_num}}次</span>
                </div>
                <div class="right">
                  <div class="lefttext">
                    <span class="name">{{item.name}}</span>
                    <span
                      class="couponGroup"
                      v-if="item.is_coupon_group=='1'"
                    >使用规则：优惠券的使用时间及适用条件以每张券具体规则为准</span>
                    <span class="time" v-if="item.is_coupon_group=='0'">{{item.end_time}}到期</span>
                    <span
                      class="time"
                      v-if="item.is_coupon_group=='0'"
                    >每个用户限领{{item.get_limit_num}}次</span>
                    <!-- <span class="area" v-if="item.area_name">
                      限定专场可用
                      <img
                        v-if="Number(item.user_get_num)>=Number(item.get_limit_num)"
                        src="./../../assets/images/myCoupon/fill1.png"
                        alt
                      />
                      <img v-else src="./../../assets/images/myCoupon/fill2.png" alt />
                    </span> -->
                  </div>
                  <div class="rightimg">
                    <img
                      v-if="Number(item.user_get_num)<Number(item.get_limit_num)"
                      src="../../assets/images/securities/one.png"
                      alt
                    />
                    <span
                      v-if="Number(item.user_get_num)<Number(item.get_limit_num)"
                      class="receive"
                      @click.stop="collar(item.nbr,index)"
                    >一键领取</span>
                    <img
                      v-if="Number(item.user_get_num)>=Number(item.get_limit_num)"
                      src="../../assets/images/securities/two.png"
                      alt
                    />
                    <span
                      v-if="Number(item.user_get_num)>=Number(item.get_limit_num)"
                      class="receives"
                    >已领取</span>
                  </div>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import weChatShareApi from "../../assets/js/weChatShare";
export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      isLoading: false,
      numPerPage: 10,
      active: 1, //初始显示那个类
      areaShow: false,
      areaText: "",
      areaTitle: '',
      menu: [
        {
          list: [],
          pageIndex: 0,
          totalRows: 0,
          loading: true, //上拉加载
          finished: false //加载完成
        },
        {
          list: [],
          pageIndex: 0,
          totalRows: 0,
          loading: true, //上拉加载
          finished: false //加载完成
        }
      ],
      total_coupons: "0",
      total_group: "0",
      respResult: ""
    };
  },
  watch: {
    active(val, old) {
      this.menu[0].list = [];
      this.menu[1].list = [];
      this.menu[val].pageIndex = 0;
      this.menu[val].loading = true;
      this.menu[val].finished = false;
      this.getData();
    },
    total_coupons(val, old) {
      if (val == 0 && this.total_group != 0) {
        this.active = 1;
      }
    },
    total_group(val, old) {
      if (val == 0 && this.total_coupons != 0) {
        this.active = 0;
      }
    }
  },
  computed: {},
  methods: {
    onRefresh() {
      this.menu[this.active].pageIndex = 0;
      this.menu[this.active].finished = false;
      this.menu[this.active].loading = true;
      this.menu[this.active].list = [];
      this.getData();
      this.getNum();
    },
    collar(nbr, index) {
      let that = this;
      let obj;
      if (this.active == 0) {
        obj = {
          user_nbr: this.userInfo.nbr,
          coupon_template_nbr: nbr,
          amount: 1
        };
      } else {
        obj = {
          user_nbr: this.userInfo.nbr,
          group_nbr: nbr,
          amount: 1
        };
      }
      this.$commonPost({
        jydm: "flow_70071",
        flow_70071: obj
      })
        .then(response => {
          that.respResult = response.resp_result;
          that.menu[that.active].list[index].user_get_num =
            parseInt(that.menu[that.active].list[index].user_get_num) + 1;
          this.$toast({
            message: "领取成功",
            duration: 2000
          });
        })
        .catch(err => {
          console.log(err.resp_result);
          this.respResult = err.resp_result;
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    showArea(item) {
      if(item.commodity_name){
        this.areaShow = true;
        this.areaTitle = '商品'
        this.areaText = item.commodity_name;
      }
      if(item.area_name){
        this.areaShow = true;
        this.areaTitle = '专场'
        this.areaText = item.area_name;
      }
    },
    getData() {
      let that = this;
      // 列表查询
      this.$commonPost({
        jydm: "flow_70109",
        flow_70109: {
          user_nbr: this.userInfo.nbr,
          is_coupon_group: this.active,
          area_nbr: this.$route.query.nbr,
          page_index: this.menu[this.active].pageIndex * this.numPerPage,
          num_per_page: this.numPerPage
        }
      })
        .then(response => {
          let arr = [];
          if (response.total_rows > 0) {
            if (response.coupon.length > 0) {
              arr = response.coupon;
            } else {
              arr.push(response.coupon);
            }
          }
          this.menu[this.active].list = this.menu[this.active].list.concat(arr);
          if (response.total_rows == this.menu[this.active].list.length) {
            this.menu[this.active].finished = true;
          } else {
            this.menu[this.active].pageIndex += 1;
            this.menu[this.active].finished = false;
          }
          this.isLoading = false;
          this.menu[this.active].loading = false;
        })
        .catch(err => {
          this.isLoading = false;
          this.menu[this.active].loading = false;
          this.menu[this.active].finished = true;
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    getNum() {
      // 总数查询
      this.$commonPost({
        jydm: "flow_70118",
        flow_70118: {
          user_nbr: this.userInfo.nbr,
          area_nbr: this.$route.query.nbr,
        }
      })
        .then(response => {
          this.total_coupons = response.total_coupons||0;
          this.total_group = response.total_group||0;
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    }
  },
  created() {
    document.title = "专区优惠券";
    let option = {
      title: "有米@" + this.userInfo.name + "的店铺",
      desc: "欢迎光临我的店铺",
      link: location.origin + "/?supNbr=" + this.userInfo.nbr,
      images: this.userInfo.imgUrl
    };
    this.weChatShare(option);
  },
  mounted() {
    if (!(this.userInfo && this.userInfo.nbr)) {
      return this.$router.replace({ path: "/index" });
    }
    this.$commonPost({
      jydm: "flow_70118",
      flow_70118: {
        user_nbr: this.userInfo.nbr,
        area_nbr: this.$route.query.nbr,
      }
    })
      .then(response => {
        this.total_coupons = response.total_coupons||0;
        this.total_group = response.total_group||0;
        if (response.total_coupons == 0 && response.total_group != 0) {
          this.active = 1;
          this.getData();
        } else {
          this.active = 0;
        }
      })
      .catch(err => {
        this.$toast({
          message: err.message,
          duration: 2000
        });
      });
  }
};
</script>
<style scoped lang='stylus'>
.wrapper.noTabs >>> .van-tabs {
  padding-top: 0;
}

.wrapper.noTabs >>> .van-pull-refresh {
  min-height:100vh;
}

.wrapper.noTabs >>> .van-hairline--top-bottom {
  display: none;
}

.wrapper >>> .van-pull-refresh {
  min-height: calc(100vh - 1.08rem);
}

.wrapper >>> .van-tab {
  font-size: 0.3rem;
  color: #333;
}

.wrapper >>> .van-tabs__wrap {
  padding: 0 0.3rem;
  border-bottom:1px solid #eee;
}

.wrapper >>> .van-tab--active {
  font-weight: normal !important;
  color: #E52B25;
}

.wrapper >>> .van-popup {
  border-radius: 0.2rem;
}
</style>
<style lang="less" scoped>
.no {
  margin-top: 1.9rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  div {
    margin-top: 0.3rem;
    color: #999;
  }
  img {
    width: 2.94rem;
    height: 1.78rem;
  }
}
.areaPopup {
  width: 5.92rem;
  height: 3.34rem;
  background: #fff;
  .areaTitle {
    text-align: center;
    line-height: 0.5rem;
    margin-top: 0.4rem;
    margin-bottom: 0.54rem;
    font-size: 0.36rem;
    font-weight: bold;
  }
  .areaText {
    padding-left: 0.3rem;
    padding-right: 0.3rem;
    font-size: 0.28rem;
    line-height: 0.4rem;
  }
}
.area {
  font-size: 0.2rem;
  color: #333;
  line-height: 0.3rem;
  margin-top: 0.1rem;
  display: flex;
  align-items: center;
  padding: 0;
  img {
    width: 0.24rem;
    height: 0.24rem;
    margin-left: 0.06rem;
  }
}
.wrapper.noTabs {
  .bottom {
    .listItem {
      margin-top: 0.34rem;
    }
  }
}
.wrapper {
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  .top {
    img {
      width: 100%;
      height: 3.04rem;
    }
  }
  .bottom {
    width: 100%;
    border-radius: 0.3rem;
    background: #ffffff;
    position: absolute;
    box-sizing: border-box;
    min-height: 100vh;
    .listItem {
      margin-top: 0.2rem;
      padding: 0 0.3rem;
      // height: calc(100vh - 3.68rem);
    }
    .volume.active {
      .left {
        border-color: #999;
        border-right: 1px dashed;
        color: #ccc;
        &::before {
          border: 1px solid #999;
        }
        &::after {
          border: 1px solid #999;
        }
        .one {
          color: #ccc;
          span {
            color: #ccc;
          }
        }
        .two {
          color: #ccc;
        }
      }
      .right {
        border: 1px solid #999;
        border-left: 0;
        .lefttext {
          .name {
            color: #ccc;
          }
          .time {
            color: #ccc;
          }
          .couponGroup {
            color: #ccc;
          }
          span {
            color: #ccc;
          }
        }
      }
    }
    .volume {
      height: 1.88rem;
      display: flex;
      overflow: hidden;
      margin-bottom: 0.2rem;
      .left {
        width: 2.15rem;
        position: relative;
        border: 1px solid #333333;
        border-right: 1px dashed #999999;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .one {
          font-weight: bold;
          font-size: 0.6rem;
          color: #000000;
          display: flex;
          justify-content: center;
          align-items: baseline;
          .amount {
            display: inline-block;
          }
          span {
            font-size: 0.3rem;
            color: #000000;
          }
        }
        .two {
          margin-top: 0.2rem;
          font-size: 0.22rem;
          color: #999999;
        }
      }
      .left::before {
        content: "";
        width: 0.2rem;
        height: 0.2rem;
        position: absolute;
        top: -0.1rem;
        right: -0.13rem;
        border: 1px solid #333333;
        border-radius: 50%;
        background: #ffffff;
      }
      .left::after {
        content: "";
        width: 0.2rem;
        height: 0.2rem;
        position: absolute;
        bottom: -0.1rem;
        right: -0.13rem;
        border: 1px solid #333333;
        border-radius: 50%;
        background: #ffffff;
      }
      .right {
        width: 4.75rem;
        border: 1px solid #333333;
        border-left: 0;
        display: flex;
        .lefttext {
          width: 3.7rem;
          height: 1.64rem;
          margin-top: 0.12rem;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 0 0.24rem 0 0.28rem;
          box-sizing: border-box;
          .name {
            font-size: 0.28rem;
            color: #333333;
            font-weight: bold;
            line-height: 0.4rem;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .time {
            font-size: 0.22rem;
            color: #999999;
            margin-top: 0.1rem;
            line-height: 0.3rem;
          }
          .couponGroup {
            margin-top: 0.1rem;
            font-size: 0.2rem;
            color: #999999;
            line-height: 0.28rem;
          }
        }
        .rightimg {
          position: relative;
          right: -2px;
          top: -1px;
          img {
            width: 1.04rem;
            height: 1.88rem;
          }
          .receive {
            writing-mode: tb-rl;
            font-size: 0.24rem;
            color: #ffffff;
            font-weight: bold;
            letter-spacing: 0.1rem;
            position: absolute;
            right: 0.38rem;
            top: 0.3rem;
          }
          .receives {
            writing-mode: tb-rl;
            font-size: 0.24rem;
            color: #ffffff;
            font-weight: bold;
            letter-spacing: 0.1rem;
            position: absolute;
            right: 0.38rem;
            top: 0.47rem;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/areaCoupon.vue